import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.scss';
import Header from './shared/header/header.js';
import Footer from './shared/footer/footer.js';
import Home from './pages/home/home';
import Administration from './pages/administration/administration';
import Services from './pages/services/services';
import Service from './pages/service/service';
import Requisites from './pages/requisites/requisites';
import AboutUs from './pages/about-us/about-us';
import Career from './pages/career/career';
import Schedule from './pages/schedule/schedule';
import SearchResults from './pages/search-results/search-results';

function App() {
  return (
    <BrowserRouter>
      <div className="layer"></div>

      <div id="preloader">
        <div data-loader="circle-side" />
      </div>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/about-us/" element={<AboutUs />} />
        <Route path="/career/" element={<Career />} />
        <Route path="/schedule/" element={<Schedule />} />
        <Route path="/administration/" element={<Administration />} />
        <Route path="/services/requisites" element={<Requisites />} />
        <Route path="/services/medical-services/:id" element={<Service />} />
        <Route path="/services" element={<Services />} />
      </Routes>

      <Footer />

      <div id="toTop"></div>
    </BrowserRouter>
  );
}

export default App;
